import React from 'react';
import './ProgressBar.css';

/**
 * Baustein — ProgressBar.
 * Determinater Fortschrittsbalken (value/max). Token-konform.
 * Der Anzeigewert wird auf 0–100 % geclamped; das Element trägt `role="progressbar"`
 * mit `aria-valuenow`/`-min`/`-max` für Screenreader.
 *
 * Props:
 *   value — aktueller Wert
 *   max   — Maximalwert (default 100)
 *   label — optional a11y-Label
 */
export default function ProgressBar({ value, max = 100, label }) {
  const pct = max > 0 ? Math.min(100, Math.max(0, (value / max) * 100)) : 0;
  return (
    <div
      className="progress-bar"
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-label={label}
    >
      <div className="progress-bar__fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
